import Model from './BaseModel';

export default class GroupedParentMarket extends Model {
	resourceName() {
		return 'grouped_parent_markets';
	}

	fields() {
		return ['market_group_id', 'market_type', 'name', 'order', 'parent_market_id', 'is_manual'];
	}
}
